import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusDense],[button-dense],[dense]',
})
export class DenseDirective {
  @HostBinding('class.ui-button--dense') isDenseClass = true;
}
